// @ts-ignore Ignore unused commented AuthGuard import
import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideAgrAuthorization } from '@next/core-lib/authorization';
import {
  AgrNotificationEmptyModule,
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrExportModule } from '@next/core-lib/export';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { TableV2Module } from '@next/core-lib/table-v2';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { FilterComponent } from './components/filter-component/filter/filter.component';

import { DataSourceService } from './components/overview/datasource/datasource.service';
import { OfferOverviewTableComponent } from './components/overview/overview-table/offer-overview-table/offer-overview-table.component';
// eslint-disable-next-line max-len
import { RequestsOverviewTableComponent } from './components/overview/overview-table/requests-overview-table/requests-overview-table/requests-overview-table.component';
import { OverviewComponent } from './components/overview/overview.component';
import { OverviewEffects } from './components/overview/store/effects/overview.effects';
import { overviewReducer } from './components/overview/store/reducer/overview.reducer';
import { TableHeaderComponent } from './components/overview/tables-header/table-header/table-header.component';
import { OffersOverviewSlideComponent } from './components/overview-slide-in/offers/offers-overview-slide/offers-overview-slide.component';
import { OffersOverviewSlideEffects } from './components/overview-slide-in/offers/store/effects/offers-overview-slide.effects';
import { RequestsOverviewSlideComponent } from './components/overview-slide-in/requests/requests-overview-slide/requests-overview-slide.component';
import { RequestsOverviewSlideEffects } from './components/overview-slide-in/requests/store/effects/requests-overview-slide.effects';
import { DashboardComponent } from './dashboard.component';

@NgModule({
  declarations: [
    DashboardComponent,
    OverviewComponent,
    OfferOverviewTableComponent,
    TableHeaderComponent,
    FilterComponent,
    OverviewComponent,
    OfferOverviewTableComponent,
    TableHeaderComponent,
    RequestsOverviewTableComponent,
    OffersOverviewSlideComponent,
    RequestsOverviewSlideComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule,
    MatTooltipModule,
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatSortModule,
    MatTooltipModule,
    MatSortModule,
    MatButtonModule,
    AgrPageToolbarModule,
    AgrPrimaryActionModule,
    AgrNotificationEmptyModule,
    AgrFormModule,
    MatTabsModule,
    TableV2Module,
    DialogModule,
    MatDialogModule,
    AgrNotificationEmptyModule,
    MatTabsModule,
    AgrFormModule,
    AgrTableModule,
    TableV2Module,
    AgrExportModule,
    MatChipsModule,
    AgrDialogModule,
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    DataSourceService,
    provideState('offerModule', overviewReducer),
    provideEffects([OverviewEffects, OffersOverviewSlideEffects, RequestsOverviewSlideEffects]),
    provideAgrAuthorization(),
  ],
})
export class DashboardModule {}
